import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as ProductUIActions from '../actions/product-ui.actions'

export const productUiFeatureKey = 'productUi';

export interface State {
  selectedSKUuid: number;
  uiselectedProductcategory: string[]
  uiselectedProductSorting?: string
  uiselectedProductBrand: string[]
  uiselectedProductOrigCountries: string[]
  uiselectedProductPriceRange: number[]
  uiGlobalSearchKeyword: string
  uiglobalSearchKeywordForAutoComplete: string
  uiaddNewSKUSearchKeywordForAutoComplete: string
  uiaddNewSKUSearchKeywordForAutoCompleteInShoppingCart: string
  uiaddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart: string
  skuId: number,
  uiselectedPreferenceSKUId: number,
  uicreateNewClassLoading: boolean,
  uiselectedProductInStockOnly: boolean,
  uiselectedProductHalalOnly: boolean,
  uiCurrentPageNumberForProductList:number,
  uiProductDetailTableLoading: boolean
}

export const initialState: State = {
  selectedSKUuid: null,
  uiselectedProductcategory: [null],
  uiselectedProductPriceRange: [0, 500],
  uiGlobalSearchKeyword: '',
  uiglobalSearchKeywordForAutoComplete: '',
  skuId: null,
  uiselectedProductBrand: [],
  uiselectedProductOrigCountries: [],
  uiselectedPreferenceSKUId: null,
  uicreateNewClassLoading: false,
  uiaddNewSKUSearchKeywordForAutoComplete: '',
  uiaddNewSKUSearchKeywordForAutoCompleteInShoppingCart: '',
  uiaddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart: '',
  uiselectedProductInStockOnly: false,
  uiselectedProductHalalOnly: false,
  uiCurrentPageNumberForProductList:null,
  uiProductDetailTableLoading: false
};


export const reducer = createReducer(
  initialState,

  on(ProductUIActions.setSelectedProduct, (state, action) => {
    return {
      ...state,
      selectedSKUuid: action.skuId
    }
  }),

  on(ProductUIActions.clearSelectedProduct, (state) => {
    return {
      ...state,
      selectedSKUuid: initialState.selectedSKUuid
    }
  }),

  on(ProductUIActions.setSelectedProductCategory, (state, action) => {
    return {
      ...state,
      uiselectedProductcategory: action.uiselectedProductcategory
    }
  }),

  on(ProductUIActions.clearSelectedProductCategory, (state, action) => {
    return {
      ...state,
      uiselectedProductcategory: initialState.uiselectedProductcategory
    }
  }),

  on(ProductUIActions.setSelectedProductSorting, (state, action) => {
    return {
      ...state,
      uiselectedProductSorting: action.uiselectedProductSorting
    }
  }),

  on(ProductUIActions.clearSelectedProductSorting, (state, action) => {
    return {
      ...state,
      uiselectedProductSorting: initialState.uiselectedProductSorting
    }
  }),

  on(ProductUIActions.setSelectedProductBrand, (state, action) => {
    return {
      ...state,
      uiselectedProductBrand: action.uiselectedProductBrand
    }
  }),

  on(ProductUIActions.clearSelectedProductBrand, (state, action) => {
    return {
      ...state,
      uiselectedProductBrand: initialState.uiselectedProductBrand
    }
  }),

  on(ProductUIActions.setSelectedProductPriceRange, (state, action) => {
    return {
      ...state,
      uiselectedProductPriceRange: action.uiselectedProductPriceRange
    }
  }),

  on(ProductUIActions.clearSelectedProductPriceRange, (state, action) => {
    return {
      ...state,
      uiselectedProductPriceRange: initialState.uiselectedProductPriceRange
    }
  }),

  on(ProductUIActions.setGlobalSkuSearchKeyword, (state, action) => {
    return {
      ...state,
      uiGlobalSearchKeyword: action.globalKeyword
    }
  }),

  on(ProductUIActions.clearGlobalSkuSearchKeyword, (state) => {
    return {
      ...state,
      uiGlobalSearchKeyword: initialState.uiGlobalSearchKeyword
    }
  }),

  on(ProductUIActions.clearProductUIFilter, (state) => {
    return {
      ...state,
      uiselectedProductBrand: initialState.uiselectedProductBrand,
      uiselectedProductPriceRange: initialState.uiselectedProductPriceRange,
      uiselectedProductSorting: initialState.uiselectedProductSorting,
      uiselectedProductcategory: initialState.uiselectedProductcategory,
      uiGlobalSearchKeyword: initialState.uiGlobalSearchKeyword,
      uiselectedProductInStockOnly: initialState.uiselectedProductInStockOnly,
      uiselectedProductHalalOnly: initialState.uiselectedProductHalalOnly,
      uiselectedProductOrigCountries: initialState.uiselectedProductOrigCountries
    }
  }),

  on(ProductUIActions.setGlobalSearchKeywordForAutoComplete, (state, action) => {
    return {
      ...state,
      uiglobalSearchKeywordForAutoComplete: action.uiglobalSearchKeywordForAutoComplete
    }
  }),

  on(ProductUIActions.clearGlobalSearchKeywordForAutoComplete, (state) => {
    return {
      ...state,
      uiglobalSearchKeywordForAutoComplete: initialState.uiglobalSearchKeywordForAutoComplete
    }
  }),

  on(ProductUIActions.setAddNewSKUSearchKeywordForAutoComplete, (state, action) => {
    return {
      ...state,
      uiaddNewSKUSearchKeywordForAutoComplete: action.uiaddNewSKUSearchKeywordForAutoComplete
    }
  }),

  on(ProductUIActions.clearAddNewSKUSearchKeywordForAutoComplete, (state) => {
    return {
      ...state,
      uiaddNewSKUSearchKeywordForAutoComplete: initialState.uiaddNewSKUSearchKeywordForAutoComplete
    }
  }),


  on(ProductUIActions.setAddNewSKUSearchKeywordForAutoCompleteInShoppingCart, (state, action) => {
    return {
      ...state,
      uiaddNewSKUSearchKeywordForAutoCompleteInShoppingCart: action.uiaddNewSKUSearchKeywordForAutoCompleteInShoppingCart
    }
  }),

  on(ProductUIActions.clearAddNewSKUSearchKeywordForAutoCompleteInShoppingCart, (state) => {
    return {
      ...state,
      uiaddNewSKUSearchKeywordForAutoCompleteInShoppingCart: initialState.uiaddNewSKUSearchKeywordForAutoCompleteInShoppingCart
    }
  }),

  on(ProductUIActions.setAddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart, (state, action) => {
    return {
      ...state,
      uiaddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart: action.uiaddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart
    }
  }),

  on(ProductUIActions.clearAddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart, (state) => {
    return {
      ...state,
      uiaddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart: initialState.uiaddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart
    }
  }),

  on(ProductUIActions.setSelectedProduct, (state, action) => {
    return {
      ...state,
      skuId: action.skuId
    }
  }),

  on(ProductUIActions.clearSelectedProduct, (state, action) => {
    return {
      ...state,
      skuId: initialState.skuId
    }
  }),

  on(ProductUIActions.setUISelectedPreferenceSKUId, (state, action) => {
    return {
      ...state,
      uiselectedPreferenceSKUId: action.uiselectedPreferenceSKUId
    }
  }),

  on(ProductUIActions.clearUISelectedPreferenceSKUId, (state, action) => {
    return {
      ...state,
      uiselectedPreferenceSKUId: initialState.uiselectedPreferenceSKUId
    }
  }),

  on(ProductUIActions.setUICreateNewClassLoading, (state, action) => {
    return {
      ...state,
      uicreateNewClassLoading: action.uicreateNewClassLoading
    }
  }),

  on(ProductUIActions.clearUICreateNewClassLoading, (state, action) => {
    return {
      ...state,
      uicreateNewClassLoading: initialState.uicreateNewClassLoading
    }
  }),

  on(ProductUIActions.setSelectedProductInStockOnly, (state, action) => {
    return {
      ...state,
      uiselectedProductInStockOnly: action.uiselectedProductInStockOnly
    }
  }),

  on(ProductUIActions.clearSelectedProductInStockOnly, (state, action) => {
    return {
      ...state,
      uiselectedProductInStockOnly: initialState.uiselectedProductInStockOnly
    }
  }),

  on(ProductUIActions.setSelectedProductHalalOnly, (state, action) => {
    return {
      ...state,
      uiselectedProductHalalOnly: action.uiselectedProductHalalOnly
    }
  }),

  on(ProductUIActions.clearSelectedProductHalalOnly, (state, action) => {
    return {
      ...state,
      uiselectedProductHalalOnly: initialState.uiselectedProductHalalOnly
    }
  }),

  on(ProductUIActions.setSelectedProductOrigCountries, (state, action) => {
    return {
      ...state,
      uiselectedProductOrigCountries: action.uiselectedProductOrigCountries
    }
  }),

  on(ProductUIActions.clearSelectedProductOrigCountries, (state, action) => {
    return {
      ...state,
      uiselectedProductOrigCountries: initialState.uiselectedProductOrigCountries
    }
  }),

  on(ProductUIActions.setCurrentPageNumberForProductList, (state,action) => {
    return {
      ...state,
      uiCurrentPageNumberForProductList:action.uiCurrentPageNumberForProductList
    }
  }),

  on(ProductUIActions.clearCurrentPageNumberForProductList, (state,action) => {
    return {
      ...state,
      uiCurrentPageNumberForProductList:initialState.uiCurrentPageNumberForProductList
    }
  }),

  on(ProductUIActions.setProductDetailTableLoading,(state,action)=>{
    return {
      ...state,
      uiProductDetailTableLoading:action.uiProductDetailTableLoading
    }
  }),


  on(ProductUIActions.clearProductDetailTableLoading,(state,action)=>{
    return {
      ...state,
      uiProductDetailTableLoading:initialState.uiProductDetailTableLoading
    }
  }),
);

